import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getPromos(page, q = '', limit = '10', status) {
    const params = {
      cursor: page,
      limit,
      q,
      status: status,
    };
    const url = '/promos';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getPromo(id) {
    return api.get(`/promos/${id}`);
  },
  hidePromo(id) {
    return api.delete(`/promos/${id}`);
  },
  deletePromo(id) {
    return api.delete(`/promos/${id}/delete`);
  },
  updatePromo(id, payload) {
    return api.put(`/promos/${id}`, { promo: payload });
  },
  updateOrderPromo(payload) {
    return api.put(`/promos/update_order`, { promos: payload });
  },
  createPromo(payload) {
    return api.post(`/promos`, { promo: payload });
  },
  restorePromo(id, data) {
    return api.put(`/promos/${id}/reactivate`, data);
  },
  getProductList(
    page,
    q = '',
    sort_by = 'created_at desc',
    limit = '10',
    minPrice,
    maxPrice,
    status
  ) {
    const params = {
      cursor: page,
      limit,
      q,
      sort_by,
      min_price: minPrice,
      max_price: maxPrice,
      status: status,
    };
    const url = '/promos/products';
    return api.get(url, { params: omitBy(params, isNil) });
  },

  downloadSingleUsedCodes(id) {
    return api.get(`promos/${id}/download_codes`);
  },
  getPromoReport(id) {
    return api.get(`/promos/${id}/download_reports`);
  },
  getAllPromoReport(status, ids) {
    const params = {
      status,
      ids,
    };
    return api.get('/promos/download_reports', {
      params: omitBy(params, isNil),
    });
  },
  bulkDelete(payload) {
    return api.post('/promos/bulk_delete', { promos: payload });
  },
  bulkChangeStatus(status, ids, data) {
    return api.post(
      `/promos/change_statuses?status=${status}&ids=${ids}`,
      data
    );
  },
};
